export enum FirestoreDateFields {
  NanoSeconds = 'nanoseconds',
  Seconds = 'seconds',
}

export interface FirestoreDateObject {
  nanoseconds: number,
  seconds: number,
}
